import { computed, inject, Injectable, signal } from '@angular/core';
import { AppMenuService, getUrl, RouteDef } from '@cumlaude/shared-components-menu';
import { Params } from '@angular/router';
import { QueryParamStateService } from './query-param-state.service';
import { getWeergaveOpties, getWeergaveOptiesWithGroepering, isTopLevelRoute, routeNaam, UserRouteData } from './user-routes.service';

const MENU_ICON_SIZE = 36;

const MENU_ICON_COUNT = 3;

const AVATAR_BUTTON_SIZE = 40;

const AVATAR_BUTTON_MARGIN_LEFT = 6;

const HEADER_PADDING_RIGHT = 24;

@Injectable({
	providedIn: 'root',
})
export class UserMenuService extends AppMenuService<UserRouteData> {
	readonly qp = inject(QueryParamStateService);

	readonly rightTopLevelMenuItemSize = signal(
		MENU_ICON_COUNT * MENU_ICON_SIZE + AVATAR_BUTTON_MARGIN_LEFT + AVATAR_BUTTON_SIZE + HEADER_PADDING_RIGHT
	).asReadonly();

	readonly dashboard = computed(() => {
		const currentPath = this.currentUrlService.currentPath();
		if (!currentPath) return undefined;

		return this.tabMenus()
			.flatMap((tabMenu) => tabMenu.menus)
			.find((item) => getUrl(item) === currentPath);
	});

	//TODO CL-7183 dashboard specifieke filters niet meer weghalen via menu
	removeFilters = [
		'ds_nm_bbs_uitzondering_van',
		'ds_nm_obs_uitzondering_van',
		'ds_nm_op_uitzondering_van',
		'ds_nm_plaatsing_uitzondering',
		'ds_nm_prestatieanalyse_vso_uitzondering',
	];

	override matchTopLevelMenuQueryParams(route: RouteDef<UserRouteData>): Params {
		return this.matchQueryParams(getWeergaveOpties(route));
	}

	override matchTabMenuQueryParams(route: RouteDef<UserRouteData>): Params {
		return this.matchQueryParams(getWeergaveOptiesWithGroepering(route));
	}

	override isTopLevelMenu(routeData: UserRouteData): boolean {
		return isTopLevelRoute(routeData);
	}

	override getName(routeData: UserRouteData): string {
		return routeNaam(routeData);
	}

	private matchQueryParams(weergaveOpties?: string[]): Params {
		const filteredQueryParams = this.qp.getNotThisDashboardQueryParamOptions(weergaveOpties);

		return this.qp.getQueryParametersNulled([...filteredQueryParams, ...this.removeFilters]);
	}
}
